import { PageUrl } from '../../pages/utils/page-url';
import type { RawUrl } from '../../utils/api';

export const preloadAbsUrls: RawUrl[] = [
    {
        action: PageUrl.PAGE_SHOW,
        args: ['cid', 'email_signup_15_off_75_details'],
    },

    {
        action: PageUrl.SEARCH_SHOW,
        args: ['cgid', 'in-store-classes'],
    },

    {
        action: PageUrl.PAGE_SHOW,
        args: ['cid', 'terms_and_conditions'],
    },
];
